import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "../../../../components/ui/card";
import { Progress } from "../../../../components/ui/progress";
import { Skeleton } from "../../../../components/ui/skeleton";
import { SessionHealthProps } from './types';

const SessionHealthCard: React.FC<SessionHealthProps> = ({
  sessionStats,
  isLoadingSessions
}) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Session Health</CardTitle>
        <CardDescription>
          Overview of session distribution across pods
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoadingSessions ? (
          <div className="space-y-4">
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        ) : sessionStats.total === 0 ? (
          <div className="text-center text-muted-foreground">
            No sessions found. Click "Load Sessions" to fetch session data.
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex flex-col space-y-2">
              <div className="flex justify-between">
                <span className="text-sm font-medium">Active in Pod ({sessionStats.activeInPod})</span>
                <span className="text-sm text-muted-foreground">
                  {Math.round((sessionStats.activeInPod / sessionStats.total) * 100)}%
                </span>
              </div>
              <Progress 
                value={(sessionStats.activeInPod / sessionStats.total) * 100} 
                className="h-2 [&>div]:bg-green-600"
              />
            </div>
            
            <div className="flex flex-col space-y-2">
              <div className="flex justify-between">
                <span className="text-sm font-medium">Missing Pod ({sessionStats.missingPod})</span>
                <span className="text-sm text-muted-foreground">
                  {Math.round((sessionStats.missingPod / sessionStats.total) * 100)}%
                </span>
              </div>
              <Progress 
                value={(sessionStats.missingPod / sessionStats.total) * 100} 
                className="h-2 [&>div]:bg-amber-600"
              />
            </div>
            
            <div className="flex flex-col space-y-2">
              <div className="flex justify-between">
                <span className="text-sm font-medium">No Pod ({sessionStats.noPod})</span>
                <span className="text-sm text-muted-foreground">
                  {Math.round((sessionStats.noPod / sessionStats.total) * 100)}%
                </span>
              </div>
              <Progress 
                value={(sessionStats.noPod / sessionStats.total) * 100} 
                className="h-2 [&>div]:bg-red-600"
              />
            </div>
            
            <div className="mt-4 text-sm text-muted-foreground">
              <p className="mb-1"><span className="font-medium text-green-600">Active in Pod:</span> Session is assigned to a running pod</p>
              <p className="mb-1"><span className="font-medium text-amber-600">Missing Pod:</span> Session has a podId but the pod doesn't exist (terminated)</p>
              <p><span className="font-medium text-red-600">No Pod:</span> Session is not assigned to any pod</p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SessionHealthCard; 